export default __webpack_public_path__ + "static/media/1148.232ddfe3.png";